import { render, staticRenderFns } from "./ClientsODC.vue?vue&type=template&id=7c0c264b"
import script from "./ClientsODC.vue?vue&type=script&lang=js"
export * from "./ClientsODC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports